import React from "react";
import {
  findExpirationRenewalDate,
  formatMonto,
  S3_ENDPOINT,
} from "../../utils";
import StatusBadge from "../global/StatusBadge";
import moment from "moment";

const PurchaseRow = ({ purchase, cancelSubscription }) => {
  const validClassPackage = () => {
    return purchase.class_package && purchase.class_package !== null;
  };

  const renderActions = () => {
    if (validClassPackage()) {
      return (
        <td>
          {renderFile()}
          {renderLink()}
          {renderCancel()}
        </td>
      );
    }
    return <td>{renderCancel()}</td>;
  };

  const renderFile = () => {
    if (
      purchase.class_package.downloadable &&
      purchase.class_package.downloadable !== null
    ) {
      return (
        <a
          href={`${S3_ENDPOINT}/${purchase.class_package.downloadable.name}.${purchase.class_package.downloadable.type}`}
          className="btn btn-sm btn-outline-secondary"
        >
          <i className="fa fa-file"></i>
        </a>
      );
    }
  };

  const renderLink = () => {
    if (
      purchase.class_package.file_url &&
      purchase.class_package.file_url !== null
    ) {
      return (
        <a
          rel="noreferrer"
          target="_blank"
          href={purchase.class_package.file_url}
          className="btn btn-sm btn-outline-secondary"
        >
          <i className="fa fa-link"></i>
        </a>
      );
    }
  };

  const renderCancel = () => {
    if (purchase.subscription_id !== null) {
      if (["active", "paused", "on-hold"].includes(purchase.status)) {
        return (
          <button
            className="btn btn-outline-danger btn-sm"
            onClick={() => cancelSubscription(purchase)}
          >
            <i className="fa fa-times"></i>
          </button>
        );
      }
    }
  };

  const renderClassPackage = () => {
    if (validClassPackage()) {
      if(purchase.class_package_id === 19285) {
        return <span>TBM Online <span className="bg-primary badge badge-pill text-white">50% Off 2 Meses</span></span>
      }
      return purchase.class_package.title;
    }
  };

  const next_invoice_date = findExpirationRenewalDate(purchase);

  const renderExpiraEn = () => {
    if (!["completed", "cancelled"].includes(purchase.status)) return null;
    const expirationDays =
      purchase.expiration_days ?? purchase.class_package?.expiration_days;
    if (expirationDays == null) return null;
    return moment(purchase.createdAt)
      .add(expirationDays, "days")
      .format("DD MMM YYYY");
  };

  return (
    <tr>
      <td className="">#{purchase.purchase_id}</td>
      <td className="">{renderClassPackage()}</td>
      <td className="">
        {"$"}
        {formatMonto(purchase.total_payment)} {"MXN"}
      </td>
      <td className="">
        {moment(purchase.createdAt).format("DD MMM YYYY HH:mm")}
      </td>
      <td className="">
        <StatusBadge {...purchase} />
      </td>
      <td>{renderExpiraEn() ?? "—"}</td>
      <td>{next_invoice_date}</td>
      {renderActions()}
    </tr>
  );
};

export default PurchaseRow;
